export function selectSystemMaintenanceMessage(state) {
  return state.systemMaintenanceMessage;
}

export function selectSystemMaintenanceShowUntilTime(state) {
  return state.systemMaintenanceShowUntilTime;
}
